import React, { useState } from 'react';

export const PlacesSelector = ({label, selectType, param, action, itemLimit, disabled}) => {
  const [visible, setVisible] = useState(false);

  const handleOptionClick = (val) => {
    if (!disabled) {
      action(selectType, val);
      toggleVisible();
    }
  };

  const toggleVisible = () => {
    if (!disabled) setVisible(!visible);
  };

  return (
    <>
      <div className="col 12 m7 s7"><label>{label}</label></div>
      <div className="col 12 m5 s5">
        <ul 
          className="list-unstyled go-rounds "
          style={{opacity: disabled ? 0.4 : 1 }}
          onClick={toggleVisible}
          onBlur={toggleVisible} >
          <li className="init"  >{ param != null ? param : `Please select`}</li>
          <li className="go-rounds ul-dropbox-2" style={{display: visible && 'list-item'}}>
            <ul name="goroundslist" className={itemLimit > 9 && `placesSelectDropdown`}>
              {Array.from(Array(itemLimit + 1)).map((x,i) => (
                <li 
                  key={i}
                  className={`go-rounds-val ${param === i && 'selected'}`} 
                  onClick={() => handleOptionClick(i)}>
                    {i}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};